"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const hero_bg_png_1 = __importDefault(require("../../../images/hero-bg.png"));
const common_styled_components_1 = require("../common-styled-components");
const react_router_dom_1 = require("react-router-dom");
const theme_1 = require("../../theme");
const UserSection_1 = require("../page-components/UserSection");
const HeaderImageContainer = styled_components_1.default.div `
  width: 100%;
  min-height: ${(props) => props.minHeight ? `${props.minHeight}px` : "150px"};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background: url(${hero_bg_png_1.default}) no-repeat center;
  background-size: cover;
  border-radius: ${(p) => p.roundTop
    ? `${common_styled_components_1.DEFAULT_RADIUS} ${common_styled_components_1.DEFAULT_RADIUS} 0 0`
    : `0 ${common_styled_components_1.DEFAULT_RADIUS} 0 0`};
  padding: ${theme_1.theme.spacing(3)} ${theme_1.theme.spacing(4)};

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    border-radius: ${common_styled_components_1.DEFAULT_RADIUS} ${common_styled_components_1.DEFAULT_RADIUS} 0 0;
  }
  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    border-radius: 0;
  }
`;
const ToolName = styled_components_1.default.h1 `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(3)};
  color: white;
  margin: 0;
`;
const getToolName = (currentPath) => {
    const pathStart = currentPath.split("/")[1];
    switch (pathStart) {
        case "fleet-calculator":
            return "Fleet Calculator";
        case "voyage-calculator":
            return "Voyage Calculator";
        case "compliance":
            return "Compliance Pooling";
        case "surplus-calculator":
            return "Surplus Calculator";
        case "biofuel-switch-calculator":
            return "Biofuel Switch Calculator";
        default:
            return null;
    }
};
const HeaderImage = ({ roundTop, minHeight, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const currentRoute = location.pathname;
    const toolName = getToolName(currentRoute);
    return ((0, jsx_runtime_1.jsxs)(HeaderImageContainer, { roundTop: roundTop, minHeight: minHeight, children: [(0, jsx_runtime_1.jsx)(ToolName, { children: toolName }), (0, jsx_runtime_1.jsx)(UserSection_1.UserSection, { light: true, hideOnBigScreen: true })] }));
};
exports.default = HeaderImage;
